import { render, staticRenderFns } from "./CustomFileUpload.vue?vue&type=template&id=255bc456&lang=pug&"
import script from "./CustomFileUpload.vue?vue&type=script&lang=js&"
export * from "./CustomFileUpload.vue?vue&type=script&lang=js&"
import style0 from "./CustomFileUpload.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports